import { bountiesApi } from "../store/api/bountiesApi";
import { runMutation, runQuery } from "../store/api/runtime";
import type { PagedResult } from "./trades";
import type { LocationSnapshot } from "../types/location";

export interface BountyItem {
  id: string;
  userId: string;
  cardName: string;
  game: string;
  cardGame?: string;
  cardId?: string;
  cardNameCanonical?: string;
  desiredCondition?: string;
  gradingCompany?: string;
  gradeNumber?: string;
  photoUrl?: string;
  zipCode?: string;
  location?: LocationSnapshot | null;
  countryCode?: string;
  locationLabel?: string;
  distanceMiles?: number;
  radius?: number;
  status?: string;
  createdAt?: string;
  boostExpiresAt?: string | null;
  lastBoostedAt?: string | null;
  ownerVerified?: boolean;
  matchCount?: number;
  [key: string]: unknown;
}

export interface CreateBountyPayload {
  userId: string;
  cardName: string;
  game: string;
  cardGame?: string;
  cardId?: string;
  cardNameCanonical?: string;
  desiredCondition?: string;
  gradingCompany?: string;
  gradeNumber?: string;
  zipCode?: string;
  radius?: number;
  file: Blob | File;
}

export async function getBounties(
  params?: Record<string, string | number | boolean | undefined>,
): Promise<PagedResult<BountyItem>> {
  return runQuery(bountiesApi.endpoints.getBounties.initiate, params);
}

export async function getBountyById(id: string): Promise<BountyItem> {
  return runQuery(bountiesApi.endpoints.getBountyById.initiate, id);
}

export async function createBounty(payload: CreateBountyPayload): Promise<unknown> {
  return runMutation(bountiesApi.endpoints.createBounty.initiate, payload);
}

export async function createBountyMatch(bountyId: string, payload: Record<string, unknown>): Promise<unknown> {
  return runMutation(bountiesApi.endpoints.createBountyMatch.initiate, { bountyId, payload });
}

export async function getBountyMatchCount(bountyId: string): Promise<{ matchCount?: number }> {
  return runQuery(bountiesApi.endpoints.getBountyMatchCount.initiate, bountyId);
}

export async function getMyBountyMatches(userId: string): Promise<unknown[]> {
  return runQuery(bountiesApi.endpoints.getMyBountyMatches.initiate, userId);
}

export async function deleteBounty(id: string): Promise<unknown> {
  return runMutation(bountiesApi.endpoints.deleteBounty.initiate, id);
}

export async function updateBountyLocation(id: string, location: LocationSnapshot): Promise<unknown> {
  return runMutation(bountiesApi.endpoints.updateBountyLocation.initiate, { id, location });
}
